<template>
<div class="space-bottom-big">
  <h4 class="title is-5 has-text-centered">Players</h4>
  <div class="columns is-mobile is-multiline is-centered">
    <div class="column is-narrow" v-for="p in players" :key="p.id">
      <div>
        <div class="user-icon has-text-centered">
          <i class="fas fa-3x fa-user has-text-info"></i>
        </div>
        <div class="has-text-centered">
          {{p.data.nickName}}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ub-players',
  props: [],
  data() {
    return {
    };
  },
  computed: {
    players() {
      return this.$store.getters['trivia/players'];
    },
  },
  methods: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>

</style>
